module.exports = __webpack_public_path__ + "img/LV.e960df81.svg";